import { TEXT_BUTTON_CREATE, TEXT_BUTTON_UPDATE, TEXT_CANCEL } from 'constants/message';
import { useDialog } from 'context/DialogContext';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import './ModifyNotificationForm.css';

const propTypes = {
  notification: PropTypes.object,
  onModify: PropTypes.func,
  onCancel: PropTypes.func
};
const defaultProps = {
  notification: {},
  onModify: (notification) => { },
  onCancel: () => { }
};

export default function ModifyNotificationForm(props) {
  /*** States and Variables ***/
  const { notification } = props;
  const { error } = useDialog()
  const {
    register, handleSubmit, reset
  } = useForm();

  useEffect(() => {
    reset({
      startDate: moment(notification.startDate).format('YYYY-MM-DD'),
      endDate: moment(notification.endDate).format('YYYY-MM-DD'),
      content: notification.content
    })
  }, [notification])

  /*** Event Handlers ***/
  const onSubmit = (data) => {
    if (notification.id) {
      data.id = notification.id;
    }
    if (moment(data.endDate).isBefore(data.startDate)) {
      error('終了日時は開始日時より後に設定してください')
      return;
    }
    data.startDate = moment(data.startDate).startOf('day')
    data.endDate = moment(data.endDate).endOf('day')
    props.onModify(data);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='modify_notification_setting_form'>
      <div className='modify_notification_setting_form_time_setting'>
        <div>表示期間</div>
        <div className='modify_notification_setting_form_time_setting_input'>
          <input {...register('startDate')} type='date' />
          <div>~</div>
          <input {...register('endDate')} type='date' />
        </div>
      </div>
      <div className='modify_notification_setting_form_content'>
        <div>お知らせ内容</div>
        <textarea {...register('content')} rows={7} />
      </div>
      <div className='modify_notification_form_button_container'>
        <button className='modify_notification_form_button button_active'>
          {notification.id ? TEXT_BUTTON_UPDATE : TEXT_BUTTON_CREATE}
        </button>
        <button
          type='button'
          className='modify_notification_form_button button_cancel'
          onClick={props.onCancel}>
          {TEXT_CANCEL}
        </button>
      </div>
    </form>
  )
}


ModifyNotificationForm.propTypes = propTypes;
ModifyNotificationForm.defaultProps = defaultProps;